// extracted by mini-css-extract-plugin
export default {"bigblue":"ModuleCSS_bigblue__Tbm2S"};